export { default, BaseWalletConnectionWrapper } from './WalletConnectionWrapper';
